export const CRM_EXPORT_DISABLED_MESSAGES = {
  NON_OPS_NON_CRM_ADMIN: 'You must be a CRM or Ops Admin to enable this feature',
  OPS_ADMIN_NO_CRM_ADMIN: 'A CRM admin is required to configure export.',
  GENERIC_DISABLED: 'Only CRM/Ops admins can enable CRM Exports',
} as const;


